<div class="w-full">
  <h4 class="title text-hard-blue">Olá {{ usage.name }}.</h4>

  <div *ngIf="usage" class="bg-white p-5 flex flex-wrap gap-4">
    <app-mini-square
      class="w-full md:w-52"
      title="Chamados Abertos por você"
      [variation]="usage.userCallOpened"
    ></app-mini-square>

    <app-mini-square
      *ngIf="user.can_see_all"
      class="w-full md:w-52"
      title="Chamados da Empresa abertos"
      [value]="usage.businessCallOpened"
    ></app-mini-square>

    <app-mini-square
      *ngIf="user.can_see_all"
      class="w-full md:w-52"
      title="Todas as Faturas da Empresa"
      [value]="usage.bills"
    ></app-mini-square>
  </div>
</div>
